import React from 'react'

import strings from '../../../strings'
import { useOnline } from '../useOnline'

import './offlineIndicator.less'

/**
 * A glyph in the title bar saying the connection has gone. Persistent rather than a toast: the
 * condition lasts, so an announcement that disappears leaves the visitor guessing later.
 *
 * Not a button — there is nothing to press, and a focusable control that does nothing is worse than a
 * mark that does not take focus. `role="status"` is what carries the sentence the glyph stands in for
 * to a screen reader, on appearance and again if the connection drops later.
 */
const OfflineIndicator: React.FC = () => {
	const online = useOnline()
	if (online) return null

	return (
		<span className="offline-indicator" role="status" aria-label={strings.offline_banner}>
			<i className="fal fa-cloud-slash" aria-hidden="true" />
		</span>
	)
}

export default OfflineIndicator
